import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-3654">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-3655">
        <h2 className="text-lg md:text-xl font-medium text-white/80 tracking-widest uppercase" data-id="element-3656">
          Product Introduction
        </h2>
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-3657">
          Wire EDM Machines
        </h1>
        <p className="text-xl text-white font-medium" data-id="element-3658">
          For Precision Machining
        </p>
      </div>
    </div>;
}